<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
		{{title}}
	</h4>
</div>

<div class="m-t-20 m-b-20">

    {{#if meterName}}
    <div class="row m-t-20 m-b-20">
        <div class="col-sm-6">
            <span><b>{{TR "Zugehöriger Zähler"}}:</b></span>
        </div>
        <div class="col-sm-6">
            <span>{{meterName}}</span>
        </div>
    </div>
    {{/if}}
    {{#if circuits}}
    <div class="row m-t-20 m-b-20">
        <div class="col-sm-6">
            <span><b>{{TR "Zugehörige Heizkreise"}}:</b></span>
        </div>
        <div class="col-sm-6">
            <ul>
            {{#each circuits}}
            <li>{{this}}</li>
            {{/each}}
            </ul>
        </div>
    </div>
    {{/if}}

    {{#unless isActive}}
    <div class="row m-t-20 m-b-20">
        <div class="col-sm-12">
            <div class="checkbox checkbox-primary">
                <input id="is-dry-run" name="is_dry_run" type="checkbox" {{#if isDryRun}}checked="checked" {{/if}}>
                <label for="is-dry-run" class="control-label">{{TR "Vorschau-Modus"}}</label>
            </div>
        </div>
    </div>
    {{/unless}}
    
    <div class="row">
        <div class="col-sm-12">
            <div class="m-b-0 alert alert-danger {{#if isDryRun}}hidden{{/if}} js-activation-warning">
                <b>
                {{TR 'Optimierte Sollwerte werden alle 15 min online generiert und an den Regler übertragen. Dies kann zu einem veränderten Verhalten des Heizkreises führen.'}}
                </b>
            </div>
            <div id="js-preview-info" class="m-b-0 alert alert-info {{#unless isDryRun}}hidden{{/unless}}">
                <b>
                {{TR 'Im Vorschau-Modus werden fortlaufend optimierte Sollwerte generiert, jedoch nicht an den Regler übertragen. Die Zeitserie des optimierten Sollwerts kann in der Analyse-Ansicht eingesehen werden.'}}
                </b>
            </div>
        </div>
    </div>

    {{#if rvtActive}}
    <div class="row">
        <div class="col-sm-12 m-t-20">
            <div class="m-b-0 alert alert-danger {{#if isDryRun}}hidden{{/if}} js-activation-warning">
                <b>
                {{TR 'Der aktivierte Fremdwertbezug wird durch Aktivieren von Smart Temp für das Gerät automatisch beendet.'}}
                </b>
            </div>
        </div>
    </div>
    {{/if}}
</div>

<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	{{#if smartTemp}}
	<button id="js-stop" class="btn btn-white pull-left">{{#if isDryRun}}{{TR "Smart Temp-Vorschau beenden"}}{{else}}{{TR "Smart Temp beenden"}}{{/if}}</button>
	{{/if}}

    {{#unless isActive}}
	<button class="btn btn-primary {{#if smartTemp}}{{#if isDryRun}}disabled{{/if}}{{/if}}" id="js-save">{{TR "Speichern"}}</button>
    {{/unless}}
</div>
